<script lang="ts">
  import { browser } from '$app/environment';
  import { navigating } from '$app/stores';
  import Nav from './nav.svelte';
  import NProgress from 'nprogress';
  import 'nprogress/nprogress.css';
  export let data;

  NProgress.configure({
    minimum: 0.16,
  });

  $: {
    if (browser) {
      if ($navigating) {
        NProgress.start();
      }
      if (!$navigating) {
        NProgress.done();
      }
    }
  }
</script>

<header>
  <Nav />
  {#if data.status.globalNotice.length > 0}
    <section class="notice">
      {#each data.status.globalNotice as notice}
        <p>
          {@html notice}
        </p>
      {/each}
    </section>
  {/if}
</header>
<slot />

<style lang="postcss">
  header {
    display: flex;
    flex-direction: column;
    place-items: center;
  }

  .notice {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    margin: var(--space-3);
    margin-top: 0;
    align-self: stretch;
    font-size: var(--size-5);

    p {
      flex: 1;
      background-color: var(--yellow-10);
      padding: var(--space-2);
      border-radius: var(--radius-2);
      color: black;
      text-align: center;
    }
    :global(*) {
      color: black;
    }
  }
</style>
